import axios from "axios"

const controller = "/productoAlmacen"

const ProductoAlmacenService = {
    buscar: async (request) => {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    buscarRapido: async (request) => {
        const { data } = await axios.post(`${controller}/buscarRapido`, request)
        return data
    },
    obtenerKardex: async (request) => {
        const { data } = await axios.post(`${controller}/obtenerKardex`, request)
        return data
    },
}

export default ProductoAlmacenService